import React, { Component } from 'react';
import BaseComponent from '../../../components/system/base';
class StopButton extends BaseComponent {
  render() {
    return (
      <button className="StopButton" {...this.globs.touchAndClick(this.props.clicked)}>{this.translate["Stop"]}</button>
    )
  }
}

export default StopButton;


// WEBPACK FOOTER //
// ./src/content/winPrize/slotComponents/StopButton.js